export default __webpack_public_path__ + "static/media/twinCities5.f85df889.webp";